import { Icon, Button, Input, AutoComplete, Select } from 'antd';
import React, { Component } from 'react';
import './Search.css';


class Search extends React.Component {

  constructor(props) {
    console.log(props)
    super(props);
    this.state = {
      // props.dataList.filter((v,i,a)=>a.findLastIndex(v2=>(v2.projectNumber === v.projectNumber))===i)
      dataSource: props.dataList.filter(ab => ab.projectNumber !== "")
        .map(a => ({ "value": a.projectNumber + " - " + a.projectTitle, "key": a.projectId })),
      itemCount: props.dataCount,
      placeHolder: props.placeHolder,
      key: props.key
    };
  }

  render() {
    return (
      <div key={this.props.key} className="global-search-wrapper" style={{ width: 700 }}>

        <Select
          showSearch
          style={{ width: 700 }}
          placeholder={this.state.placeHolder}
          optionFilterProp="children"
          onSelect={this.props.onSelect}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {this.state.dataSource.map(fbb =>
            <option key={fbb.id} value={fbb.key}>{fbb.value}</option>
          )}
        </Select>
      </div>
    );
  }
}

export default Search;